import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import styles from "./styles.less";
import ResultBox from "../ResultsGroup/ResultBox";
import { DealWrraper } from "../DealWrraper";
import { Header } from "../../components/common";

const noop = () => {};
export class DealsGroup extends Component {
  componentDidMount() {
    this.props.onLoad();
  }

  renderBox = (result, onShowDealDetailsClick) => {
    const {
      isRtl,
      titles,
      isMobileView,
      normalizeResult,
      isDeals,
      isRegionResult,
      renderMarkup,
      renderImageMarkup,
      selectedDealId,
      onThumbnailImageLoad,
      handleSelectedDealRef
    } = this.props;
    const normalizedResult = normalizeResult ? normalizeResult(result) : result;
    const isSelectedResult = selectedDealId === result.id.toString();
    return (
      <ResultBox
        key={result && result.id + "deal"}
        innerRef={isSelectedResult ? handleSelectedDealRef : noop}
        onImageLoad={isSelectedResult ? onThumbnailImageLoad : noop}
        isMobileView={isMobileView}
        isRegionResult={isRegionResult}
        className={styles.roomReusltBoxWrapper}
        onClick={onShowDealDetailsClick}
        result={normalizedResult}
        isRtl={isRtl}
        titles={titles}
        isDeals={isDeals}
        renderMarkup={renderMarkup}
        renderImageMarkup={renderImageMarkup}
      />
    );
  };

  getDealComponents = (results, numElemsInRow) => {
    let desktopResutlsIndex = -1;
    let desktopResults = [];
    results.map((result, index) => {
      if (index % numElemsInRow == 0) {
        desktopResutlsIndex++;
        desktopResults[desktopResutlsIndex] = [];
      }
      desktopResults[desktopResutlsIndex].push(result);
    });
    return desktopResults;
  };

  getHotDeal = () => {
    const { results, showHotDeal } = this.props;
    // let sortedDealsByPrice = results.sort(function(a, b) {
    //   return a.totalPrice - b.totalPrice;
    // });
    const dealWithMinPrice =
      showHotDeal &&
      results.length > 0 &&
      results.reduce(function(p, v) {
        return p.totalPrice < v.totalPrice ? p : v;
      });
    return dealWithMinPrice;
  };

  // getFastDesicionDeal = () => {
  //   const { results } = this.props;
  //   const fastDesicionDeals =
  //     results.length > 0 &&
  //     results.map(
  //       deals =>
  //         deals.startDate.diff(deals.endDate, "days") < moment().add(30, "days")
  //     );
  //   return fastDesicionDeals;
  // };

  render() {
    const {
      results,
      isRtl,
      isMobileView,
      lang,
      onDealClick,
      routing,
      titles,
      performDealSearch,
      rooms,
      dealSearchPerformed,
      isDealMode,
      isFetchingDealSearchResults,
      lastMinuteDaysDeal,
      renderLoader,
      isIos,
      isIE
    } = this.props;
    let data = isMobileView
      ? this.getDealComponents(results, 1)
      : this.getDealComponents(results, 2);
    const dealWithMinPrice = this.getHotDeal();
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Header
              text={titles.Deals}
              isRtl={isRtl}
              isMobileView={isMobileView}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          className={styles.mainDealsGroupWrapper}
          textAlign={isRtl ? "right" : "left"}
        >
          {data.map((item, key) => (
            <DealWrraper
              deals={item}
              renderBox={this.renderBox}
              key={key}
              lang={lang}
              onDealClick={onDealClick}
              routing={routing}
              titles={titles}
              isMobileView={isMobileView}
              performDealSearch={performDealSearch}
              isRtl={isRtl}
              rooms={rooms}
              dealSearchPerformed={dealSearchPerformed}
              isDealMode={isDealMode}
              dealWithMinPrice={dealWithMinPrice}
              isFetchingDealSearchResults={isFetchingDealSearchResults}
              renderLoader={renderLoader}
              lastMinuteDaysDeal={lastMinuteDaysDeal}
              isIos={isIos}
              isIE={isIE}
            />
          ))}
        </Grid.Row>
      </Grid>
    );
  }
}

DealsGroup.defaultProps = {
  isRtl: false,
  isIE: false,
  isMobileView: false,
  isRegionResult: false,
  titles: {},
  results: []
};

DealsGroup.propTypes = {
  isRtl: PropTypes.bool,
  isIE: PropTypes.bool,
  isIos: PropTypes.bool,
  isMobileView: PropTypes.bool,
  isRegionResult: PropTypes.bool,
  titles: PropTypes.object,
  results: PropTypes.array,
  normalizeResult: PropTypes.func,
  isDeals: PropTypes.bool,
  renderMarkup: PropTypes.func,
  renderImageMarkup: PropTypes.func,
  lang: PropTypes.string,
  onDealClick: PropTypes.func,
  routing: PropTypes.object,
  performDealSearch: PropTypes.func,
  dealSearchPerformed: PropTypes.bool,
  rooms: PropTypes.object,
  isDealMode: PropTypes.bool,
  isFetchingDealSearchResults: PropTypes.bool,
  selectedDealId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  renderLoader: PropTypes.func,
  onThumbnailImageLoad: PropTypes.func,
  handleSelectedDealRef: PropTypes.func,
  showHotDeal: PropTypes.bool,
  lastMinuteDaysDeal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onLoad: PropTypes.func
};

export default DealsGroup;



// WEBPACK FOOTER //
// ./src/components/DealsGroup/DealsGroup.js